import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ChartQueryParams, HeatmapChartData } from '@frontend/chart/types';

export class PackageChartClient extends APIClient {
    public static readonly endpoint = '/package-api/v1';

    public static async fetchActivityPerHour(accountId: string, queryParams?: ApiQueryParams<ChartQueryParams>): Promise<HeatmapChartData> {
        const response = await this.fetchWithQueryParams(`${this.endpoint}/accounts/${accountId}/activity-per-hour`, undefined, true, undefined, queryParams);
        return await this.handleResponse<HeatmapChartData>(response);
    }

    public static async fetchActivityPerDay(accountId: string, queryParams?: ApiQueryParams<ChartQueryParams>): Promise<HeatmapChartData> {
        const response = await this.fetchWithQueryParams(`${this.endpoint}/accounts/${accountId}/activity-per-day`, undefined, true, undefined, queryParams);
        return await this.handleResponse<HeatmapChartData>(response);
    }

    public static async fetchOccupiedSlots(
        accountId: string,
        spotId: string,
        moduleId: string,
        queryParams?: ApiQueryParams<ChartQueryParams>
    ): Promise<HeatmapChartData> {
        const response = await this.fetchWithQueryParams(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/occupied-slots`,
            undefined,
            true,
            undefined,
            queryParams
        );
        return await this.handleResponse<HeatmapChartData>(response);
    }
}
